import { Divider } from '@mui/material';
import CertificateCard from 'components/CertificateCard';
import Loading from 'components/Loading';
import PageHeader from 'components/PageHeader';
import { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';

export default function Certifications() {
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://api.myjson.online/v1/records/ea002a4a-17bf-43b4-9d2f-433c5ed24cb8',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'm-collection-access-token':
                                '14fd5407-a000-42bb-92d8-a885c8f90f8b',
                        },
                    }
                );
                const json = await response.json();
                setData(json.data);
                console.log(json.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    return (
        <Container className='p-3'>
            
                    <PageHeader
                        Title='Certificates'
                        Description='Here is the collection of my most valuable certificates.'
                    />
                    <Loading show={!data}>
                    {data && (
                    <Row>
                        {data.certs.map((cert: any) => {
                            return (
                                <Col key={cert.name}>
                                    <CertificateCard
                                        key={cert.name}
                                        Name={cert.name}
                                        Date={cert.date}
                                        Title={cert.title}
                                        Image={cert.image}
                                        ColorRGB={cert.ColorRGB}
                                    />
                                </Col>
                            );
                        })}
                    </Row>)}
            </Loading>
        </Container>
    );
}
